<template>
  <div class="input-group">
    <div v-if="label" class="input-label">{{ label }}</div>
    <div class="relative">
      <input
        :value="modelValue"
        :type="showPassword ? 'text' : 'password'"
        class="input-item w-full pr-12"
        :placeholder="placeholder"
        @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      />
      <button type="button" class="absolute right-3 top-1/2 -translate-y-1/2 text-[#7F7F80] hover:text-white transition-colors duration-150" @click="togglePasswordVisibility">
        <EyeOpenIcon v-if="showPassword" class="w-5 h-5" />
        <EyeCloseIcon v-else class="w-5 h-5" />
      </button>
    </div>
    <slot name="errors"></slot>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import EyeOpenIcon from '@/assets/svgs/icons/eye-open.svg'
import EyeCloseIcon from '@/assets/svgs/icons/eye-close.svg'

interface Props {
  modelValue: string
  label?: string
  placeholder?: string
}

defineProps<Props>()
defineEmits<{
  'update:modelValue': [value: string]
}>()

const showPassword = ref(false)

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value
}
</script>
